<ng-container *transloco="let t">
<div style="min-height: 500px;">
  <div class="w-100">
    <div class="pb-10 pb-lg-15">
      <h2 class="fw-bolder d-flex align-items-center text-dark">{{ t('wizard.liabilities.creditsAndDebts') }}
      <i class="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title=""></i></h2>
      <div class="text-gray-400 fw-bold fs-6" style="min-height: 20px;"></div>
    </div>
    <div class="fv-row">
        <div class="row">
          <span class="col-lg-12 text-dark fw-bolder d-block fs-4 pb-2" style="min-height: 60px;">
          </span>
        </div>
    </div>
    <div class="fv-row" style="min-height: 400px;">
      <div class="row mb-10">
        <form #liabilityForm="ngForm" novalidate id="liabilityForm" name="liabilityForm">

          <div class="d-flex mb-7 row">
            <div class="col-md-4">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.accountType') }}</span>
              </label>
              <select name="typeOfLiability" required [ngClass]="{'is-invalid' : typeOfLiability && typeOfLiability.touched && typeOfLiability.invalid}"
                [(ngModel)]="liability!.typeOfLiability" class="form-select form-select-solid" #typeOfLiability="ngModel"
                [attr.data-placeholder]="t('wizard.liabilities.selectAccountType')">
                  <option></option>
                  @for (liabilityType of liabilityTypes; track liabilityType.value; let i = $index) {
                    <option [ngValue]="liabilityType.value">
                       {{liabilityType.name}}
                    </option>
                  }
              </select>
            </div>
            <div class="col-md-4">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.creditor') }}</span>
              </label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="liability!.holderName" required placeholder="" name="holderName"
                  [ngClass]="{'is-invalid' : holderName && holderName.touched && holderName.invalid}" #holderName="ngModel" />
              </div>
            </div>
            <div class="col-md-4 fv-row">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.amount') }}</span>
              </label>
              <input type="text" class="form-control form-control-solid" [(ngModel)]="liability!.unpaidBalance" required placeholder="" name="amount"
              [ngClass]="{'is-invalid' : amount && amount.touched && amount.invalid}" #amount="ngModel" />
            </div>
          </div>
          <div class="d-flex mb-7 row">
            <div class="col-md-3">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.lienType') }}</span>
              </label>
              <select name="lienPosition" required [ngClass]="{'is-invalid' : lienPosition && lienPosition.touched && lienPosition.invalid}"
                [(ngModel)]="liability!.lienPosition" class="form-select form-select-solid" #lienPosition="ngModel"
                [attr.data-placeholder]="t('wizard.liabilities.selectLienType')">
                  <option></option>
                  @for (lienType of lienTypes; track lienType.value; let i = $index) {
                    <option [ngValue]="lienType.value">
                       {{lienType.name}}
                    </option>
                  }
              </select>
            </div>
            <div class="col-md-3">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.fhaSource') }}</span>
              </label>
              <select name="fhaSource" required
                class="form-select form-select-solid"
                [attr.data-placeholder]="t('wizard.liabilities.selectFhaSource')">
                  <option></option>
                  @for (fhaSource of fhaSourceTypes; track fhaSource.value; let i = $index) {
                    <option [ngValue]="fhaSource.value">
                       {{fhaSource.name}}
                    </option>
                  }
              </select>
            </div>
            <div class="col-md-3">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.monthlyPayment') }}</span>
              </label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="liability!.monthlyPayment" required placeholder="" name="monthlyPayment"
                  [ngClass]="{'is-invalid' : monthlyPayment && monthlyPayment.touched && monthlyPayment.invalid}" #monthlyPayment="ngModel" />
              </div>
            </div>
            <div class="col-md-3">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.loanAmountDraw') }}</span>
              </label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" required placeholder="" name="loanAmont"/>
              </div>
            </div>
          </div>
          <div class="d-flex mb-7 row">
            <div class="col-md-4">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.creditLimit') }}</span>
              </label>
              <div class="position-relative">
                <input type="text" class="form-control form-control-solid" [(ngModel)]="liability!.creditLimit" required placeholder="" name="creditLimit"
                  [ngClass]="{'is-invalid' : creditLimit && creditLimit.touched && creditLimit.invalid}" #creditLimit="ngModel" />
              </div>
            </div>
            <div class="col-md-4">
              <label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
                <span class="required">{{ t('wizard.liabilities.isHeloc') }}</span>
              </label>
              <div class="position-relative">
                <input class="form-check-input" type="checkbox" value="" id="isHeloc" />
              </div>
            </div>
          </div>
          <div class="d-flex mb-7 row">

          </div>
        </form>

      </div>
    </div>
  </div>
</div>
</ng-container>
